import { useState, useEffect } from "react";
import { Tabs } from "@/components/ui/tabs";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { useToast } from "@/components/ui/use-toast";
import { SettingsHeader } from "@/components/settings/layout/SettingsHeader";
import { SettingsTabs } from "@/components/settings/layout/SettingsTabs";
import { SettingsContent } from "@/components/settings/layout/SettingsContent";

const Settings = () => {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("email");
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    const tab = searchParams.get("tab");
    if (tab) {
      setActiveTab(tab);
    }

    const success = searchParams.get("success");
    if (success === "true") {
      toast({
        title: "Purchase Successful!",
        description: "Your tokens have been added to your account.",
        duration: 5000,
      });
      // Clean up the URL
      navigate("/settings?tab=tokens", { replace: true });
    }

    const checkAdminStatus = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setIsAdmin(user?.user_metadata?.role === 'admin');
    };

    checkAdminStatus();
  }, [searchParams, navigate, toast]);

  return (
    <div className="min-h-screen bg-background">
      <SettingsHeader />

      <div className="container mx-auto py-6">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
          <SettingsTabs isAdmin={isAdmin} />
          <SettingsContent isAdmin={isAdmin} />
        </Tabs>
      </div>
    </div>
  );
};

export default Settings;